//const lysGra = #e9ecef;

// Nye farger
// Lys gul til login bildet #f6eabe;
    

const colorConfig = {
    // Lys grå for jumbotron
    jumbotron: '#e9ecef',

    login_jumbo: '#f6eabe',
    header_bg: '#FFFFFF',
    footer_bg: '#251239',
    lys_gul: '#F6EABE',
    mork: '#2E2035',
    midnatt_100: '#eae9eb',
    krem: '#F1ECE2',
    tabell_lysGul: '#f5f2eb',
    taballrad_mork: '#F0E8D9',
    tabellrad_tekst: '#62615E', 
    grid_tekst: '#62615e',
    header_tekst: '#000000',

    danger_bg: '#2E2035',
    button_bg: '#f6ff7f',
    button_focused: '#ebf655',
    bytton_hover: '#ebf655',
    modal_background: '#F1ECE2',
   
 }
 
export default colorConfig

/*
Rød for header: #FFFFFF
Lys beige for bakgrunn: #fdfbf2
Mørk beige for annenhver tabell bakgrunn: #F0E8D9 Grå tekst: #62615E
*/